import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ROW_ACTION_ICON } from '@lib/ui-components';
import { useDownloadCard } from '../hooks/use-download-card';

interface DownloadCardButtonProps {
  collectionRequestId: string;
  label?: string;
  variant?: 'contained' | 'outlined' | 'text';
}

/**
 * Button component for downloading collection request cards.
 * Uses the useDownloadCard hook to handle the download process.
 */
export const DownloadCardButton: React.FC<DownloadCardButtonProps> = ({ collectionRequestId, label }) => {
  const { t } = useTranslation();
  const { downloadCard, isDownloading } = useDownloadCard();

  const isLoading = isDownloading(collectionRequestId);

  return (
    <Button
      label={label || t('downloadCard')}
      startIcon={ROW_ACTION_ICON.download}
      color='secondary'
      variant='contained'
      onClick={() => downloadCard(collectionRequestId)}
      isDisabled={isLoading}
      forceLoadingSign={isLoading}
    />
  );
};
